import { render, staticRenderFns } from "./detailSearch.vue?vue&type=template&id=550d3d87&scoped=true&"
import script from "./detailSearch.vue?vue&type=script&lang=js&"
export * from "./detailSearch.vue?vue&type=script&lang=js&"
import style0 from "./detailSearch.vue?vue&type=style&index=0&id=550d3d87&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550d3d87",
  null
  
)

export default component.exports